import React from 'react';
import { Collapse, CardBody, Card } from 'reactstrap';
import PropTypes from 'prop-types';

function CollapseElement({ collapse, children }) {
  return (
    <div>
      <Collapse isOpen={collapse}>
        <Card>
          <CardBody>{children}</CardBody>
        </Card>
      </Collapse>
    </div>
  );
}

CollapseElement.propTypes = {
  children: PropTypes.func.isRequired,
  collapse: PropTypes.bool.isRequired,
};

export default CollapseElement;
